module.exports = __webpack_public_path__ + "img/Katarina_acc_16.b488df74.jpg";